<!-- Auth Container -->
<div class="prep-auth" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center stretch">

  <main [@fadeInUp] id="main-content" class="card" fxFlex="45" fxFlex.lt-md="100" fxLayoutAlign="start stretch"
    fxLayout="column" role="main" [attr.aria-label]="LangTextData?.ariaLabels.main">

    <form class="auth-form" [formGroup]="UserLoginFormGroup" (ngSubmit)="send()" fxLayout="column">
      <!-- Header-->
      <div fxLayout="row wrap" fxLayoutAlign="space-between center">
        <!-- Logo + APP Name-->
        <div fxFlex="70" fxFlex.sm="60" fxFlex.xs="100">
          <div fxLayoutAlign="start center">
            <a href="https://www.continualengine.com/prep-pdf-remediation-software/" target="_blank"
              rel="noopener noreferrer" class="logo-link logo-link--brand"
              [attr.aria-label]="LangTextData?.ariaLabels.prepLogoLink">
              <img src="../../../../assets/splash-screen/prep-white-icon.svg"
                [attr.alt]="LangTextData?.altLabels.prepLogo" class="auth-form-logo" />
            </a>
            <h1 class="prep-heading">
              {{ LangTextData?.htmlLabel.appName }}
            </h1>
          </div>
        </div>
        <!-- MULTI - LANG -->
        <div fxFlex="30" fxFlex.sm="40" fxFlex.xs="100" fxLayoutAlign="end center">
          <prep-language-selector></prep-language-selector>
        </div>
      </div>
      <!-- Titles -->
      <div fxLayout="row">
        <div fxFlex="100" style="padding-top: 25px;">
          <h2 *ngIf="SSOFlow" style="font-size: 34px;">
            {{ LangTextData?.htmlLabel.ssoUserLogin }}
          </h2>
          <h2 *ngIf="!SSOFlow" style="font-size: 34px;">{{ LangTextData?.htmlLabel.userLogin }}</h2>
          <h3 style="color: #136EE9; font-size: 18px; font-weight: bold">
            {{ LangTextData?.htmlLabel.appWelcome }}
          </h3>
        </div>
      </div>
      <!-- Input Fields -->
      <div fxLayout="row" style="padding-top: 15px;padding-bottom:25px;">
        <div *ngIf="!SSOFlow" fxFlex="auto" fxLayout="column">
          <small>{{ LangTextData?.htmlLabel.requiredFieldMessage }}</small>

          <mat-form-field fxFlex="grow" appearance="outline">
            <mat-label>{{ LangTextData?.htmlLabel.email }}</mat-label>

            <input matInput #emailInputRef type="email" required formControlName="username" id="username"
              [attr.aria-invalid]="isFieldInvalid('username')" [attr.aria-describedby]="getDescribedById('username')"
              (blur)="onFieldBlur('username')" />

            <!-- Hint: Instructions before input (accessible to all users) -->
            <mat-hint id="username-hint" aria-live="polite">

              <!-- Default Hint -->
              <ng-container *ngIf="!isFieldValid('username')">
                {{ LangTextData?.htmlLabel.emailInvalidError }}
              </ng-container>

              <!-- Success State -->
              <ng-container *ngIf="isFieldValid('username')">
                <span class="success-text">
                  <mat-icon aria-hidden="true">check_circle</mat-icon>
                  {{ LangTextData?.htmlLabel.emailFormatValid }}
                </span>
              </ng-container>
            </mat-hint>
            <!-- Error message: Single announcement mechanism, no role="alert" to avoid duplication -->
            <mat-error id="username-error"
              *ngIf="isFieldInvalid('username') && UserLoginFormGroup.get('username')?.touched" aria-live="polite"
              aria-atomic="true">
              <mat-icon aria-hidden="true" class="a11y-error-icon">error</mat-icon>
              <span class="a11y-error-text">
                {{ getErrorMessage('username') }}
              </span>
            </mat-error>
          </mat-form-field>

          <!-- Password Field -->
          <mat-form-field fxFlex="grow" appearance="outline" style="margin-top: 7px">
            <mat-label>{{ LangTextData?.htmlLabel.password }}</mat-label>

            <input matInput [type]="inputType" required minlength="6" formControlName="password" id="password"
              [attr.aria-invalid]="isFieldInvalid('password')" [attr.aria-describedby]="getDescribedById('password')"
              (blur)="onFieldBlur('password')" />

            <!-- Hint: Instructions before input (accessible to all users) -->
            <mat-hint id="password-hint" aria-live="polite">
              <ng-container *ngIf="!isFieldValid('password')">
                {{ LangTextData?.htmlLabel.passwordHint || 'Password must be at least 6 characters' }}
              </ng-container>

              <!-- Success State -->
              <ng-container *ngIf="isFieldValid('password')">
                <span class="success-text">
                  <!-- <mat-icon aria-hidden="true">check_circle</mat-icon> -->
                  {{ LangTextData?.htmlLabel.passwordEntererd }}
                </span>
              </ng-container>
            </mat-hint>

            <!-- Show/Hide Button: Accessible password visibility toggle -->
            <button #toggleBtn type="button" mat-icon-button matSuffix (click)="toggleVisibility(toggleBtn)"
              [attr.aria-label]="getPasswordToggleLabel()" [matTooltip]="getPasswordToggleLabel()"
              class="a11y-pwd-toggle">
              <mat-icon aria-hidden="true">{{ visible ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <!-- Error message: Single announcement mechanism, no role="alert" to avoid duplication -->
            <mat-error id="password-error"
              *ngIf="isFieldInvalid('password') && UserLoginFormGroup.get('password')?.touched" aria-live="polite"
              aria-atomic="true">
              <mat-icon aria-hidden="true" class="a11y-error-icon">error</mat-icon>
              <span class="a11y-error-text">
                {{ getErrorMessage('password') }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <!-- Remember Me & Forgot Password -->
      <div *ngIf="!SSOFlow" fxLayout="row">
        <div fxFlex="100" fxLayoutAlign="space-between center" style="padding: 10px 0px;">
          <mat-checkbox id="remember-me" class="caption" (keydown.enter)="$event.preventDefault()">
            {{ LangTextData?.htmlLabel.rememberMe }}
          </mat-checkbox>
          <a [routerLink]="['/forgot-password']" class="caption link-acc">
            {{ LangTextData?.htmlLabel.forgotPassword }}
          </a>
        </div>
      </div>
      <!-- Sign In Button -->
      <div fxLayout="row" style="padding-top: 15px;padding-bottom:25px;">
        <div fxFlex="100">
          <button mat-raised-button color="primary" class="platform-login-button" type="submit" id="submit"
            [class.disabled-btn]="UserLoginFormGroup.invalid || is_loading"
            [attr.aria-disabled]="UserLoginFormGroup.invalid || is_loading" [attr.aria-busy]="is_loading">
            <ng-container *ngIf="!is_loading; else loading">
              {{ LangTextData?.htmlLabel.signIn }}
            </ng-container>
            <ng-template #loading>
              {{ LangTextData?.htmlLabel.signInLoading }}
            </ng-template>
          </button>
        </div>
      </div>
      <!-- Privacy Policy -->
      <div fxLayout="row">
        <div fxFlex="100">
          <div class="privacy-note" role="note" style="text-align: center; margin-top: 10px"
            [attr.aria-label]="LangTextData?.ariaLabels.privacyNote">
            <p>
              {{ LangTextData?.htmlLabel.privacyPolicyHint }}<br />
              <a class="link-acc" href="https://prep.continualengine.com/privacy-policy/" target="_blank" role="link"
                [attr.aria-label]="LangTextData?.ariaLabels.privacyPolicyLink">
                {{ LangTextData?.htmlLabel.privacyPolicy }}
              </a>
            </p>
          </div>
        </div>
      </div>
      <!-- Spinner -->
      <div fxLayout="row">
        <div fxFlex="100">
          <div *ngIf="is_loading" fxLayout="row" fxLayoutAlign="center center" role="status" aria-live="polite"
            [attr.aria-busy]="is_loading" style="padding: 15px 0">
            <mat-spinner color="primary" [diameter]="40"
              [attr.aria-label]="LangTextData?.ariaLabels.loadingSpinner"></mat-spinner>
            <span class="cdk-visually-hidden">{{
              LangTextData?.ariaLabels.spinnerText
              }}</span>
          </div>
        </div>
      </div>
      <!-- Powered By -->
      <div fxLayout="row" fxLayoutAlign="center center" style="width: 100%;">
        <div style="text-align: center;">
          <span>{{ LangTextData?.htmlLabel.poweredBy }}</span><br />
          <a href="https://www.continualengine.com/" target="_blank" rel="noopener noreferrer" class="logo-link"
            [attr.aria-label]="LangTextData?.ariaLabels.continualEngineLogoLink">
            <img src="../../../../assets/Logo/ce-logo.svg" [attr.alt]="LangTextData?.altLabels.continualEngineLogo"
              height="50" />
          </a>
        </div>
      </div>
    </form>
  </main>
</div>